@import "src/globals/common.scss";

section.results {
  padding: 5px;
  border-radius: $borderRadius;
  background-color: $primaryBackgroundColor;
}

h2 {
  font-size: 1em;
  font-weight: bold;
  width: 100%;
  text-align: center;
}

.emissions-figure {
  text-align: center;
  container: emissions / inline-size;

  span:first-child {
    font-weight: bold;
    display: block;
    font-size: 6em;

    &.digits-7 {
      font-size: 5em;
    }
    &.digits-8 {
      font-size: 5em;
    }
    &.digits-9 {
      font-size: 4.5em;
    }
    &.digits-10 {
      font-size: 4.5em;
    }
  }

  @container emissions (max-width: 420px) {
    span:first-child {
      font-size: 4.5em;

      &.digits-7 {
        font-size: 4em;
      }
      &.digits-8 {
        font-size: 4.2em;
      }
      &.digits-9 {
        font-size: 3.5em;
      }
      &.digits-10 {
        font-size: 3em;
      }
    }

    span:nth-child(2) {
      font-size: 1.5em;
    }
  }
}

p,
h3 {
  text-align: center;
}

h3 {
  margin-bottom: 0;
  &.long-title {
    font-size: 0.8em;
  }
}

.airplane {
  margin-top: 10px;
  min-height: 400px;
  background: url("https://storage.googleapis.com/carbon-calculator-widget/assets/aircraft.png") center center;
  background-size: contain;
  background-repeat: no-repeat;
  container: airplane / inline-size;

  > div > p {
    font-size: 0.7em;
    font-weight: 600;
    text-align: center;
  }

  .seats-column {
    background-color: $secondaryBackgroundColorTransparent;
    margin: 0 40px;
    padding: 0 10px;
    box-sizing: content-box;
    border-radius: $borderRadius;
    &.left {
      box-shadow: -6px 6px 1px 1px $borderColor;
    }
    &.right {
      box-shadow: 6px 6px 2px 1px $borderColor;
    }
    div {
      padding: 10px 0;
      p:first-child {
        margin: 0;
        font-weight: 100;
      }
      p:nth-child(2) {
        margin-top: 5px;
        font-weight: 600;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .airplane {
    .seats-column {
      margin: 0 10px;
    }
  }
}

@container airplane (max-width: 480px) {
  .seats__title {
    font-size: 9px !important;
  }
}

.results {
  position: relative;
  container: results / inline-size;

  p {
    text-align: center;

    &.aircraft-name {
      font-size: 1.5em;
      font-weight: bold;
      margin: 0;
    }
  }

  &--equivalents {
    text-align: center;
    border-radius: 10px;
    margin: 1em 0;
  }

  &--methodology {
    text-align: center;
    margin: 2em 0 3em;
  }
}

.results-equivalents {
  &__header {
    font-weight: bold;
    margin: 1em 0;
    text-transform: uppercase;
  }

  &__subtitle {
    margin: 2em 0 1em .5em;
    font-weight: bold;
  }

  &__content {
    text-align: left;
    container: equivalents / inline-size;
  }

  &__resource {
    margin: 1em 0 0 10%;
    max-width: 80%;
    display: grid !important;
    grid-template-columns: 30px auto 1fr;
    grid-template-areas: 'col-icon col-value col-title' 'col-icon col-value col-message';

    &.mt-0 {
      margin-top: 0;
    }

    .col-icon {
      grid-area: col-icon;
      display: grid;
      align-items: center;
      height: 34px;
    }

    .col-value {
      grid-area: col-value;
    }

    .col-message {
      grid-area: col-message;
    }

    .col-title {
      grid-area: col-title;
      display: grid;
      align-items: end;
      height: 34px;
    }

    @container equivalents (max-width: 320px) {
      .results-equivalents__value {
        font-size: 1em;
        line-height: 2em;
      }

      .results-equivalents__value-title {
        font-size: .6em;
        height: 23px;
      }

      .results-equivalents__value-message {
        font-size: .75em;
      }
    }

    @container equivalents (min-width: 320px) {
      .results-equivalents__value {
        font-size: 2em;
        line-height: 1em;
      }

      .results-equivalents__value-title {
        font-size: 1.2em;

      }

      .results-equivalents__value-message {
        font-size: .9em;
      }
    }

    .results-equivalents__value {
      font-weight: bold;
      margin-left: 15px;
    }

    .results-equivalents__value-title {
      font-weight: bold;
      margin-left: .5em;
      text-transform: uppercase;
    }

    .results-equivalents__value-message {
      margin-left: 15px;

      &.ml-1 {
        margin: 0 .5em 0;
        height: 34px;
        display: grid;
        align-items: center;
        padding-bottom: 4px;
      }
    }
  }
}

.cover-spin {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 48%;
    top: 40%;
    width: 40px;
    height: 40px;
    border-style: solid;
    border-color: black;
    border-top-color: transparent;
    border-width: 4px;
    border-radius: 50%;
    -webkit-animation: spin 0.8s linear infinite;
    animation: spin 0.8s linear infinite;
  }
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
